import React from "react";
import { DatePicker, TimePicker } from "antd";
import { RenderDateInput } from "app/common/renderInput";
const format = "HH:mm";
const onChange = (date, dateString) => {
  console.log(date, dateString);
};
const DateArrival = ({
  index,
  // handleBlur,
  values,
  handleChange,
  touched,
  errors,
}) => {
  return (
    <RenderDateInput
      type="date"
      id={`flightLegs.return[${index}].arrivalDate`}
      name={`flightLegs.return[${index}].arrivalDate`}
      value={values?.flightLegs?.return[index]?.arrivalDate}
      onChange={handleChange}
    ></RenderDateInput>
  );
};

export default DateArrival;
